const DisplayError: React.FC<{ msg?: string }> = ({ msg }) => {
  if (!msg) return

  return <div className="flex font-bold border text-orange-600 justify-center">{msg}</div>
}
export default DisplayError
